import $ from 'cash-dom'

$(() => {
  const $els = {
    body: $('body'),
    zoomTrigger: $('.zoom-trigger'),
    zoomContent: $('.zoom-content'),
    zoomClose: $('.zoom-close'),
    zoomImg: $('.zoom-img'),
    zoomNext: $('.zoom-next'),
    zoomPrev: $('.zoom-prev'),
  }

  const renderArrow = () => {
    return `
      <svg width="12" viewBox="0 0 12 22" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" stroke-linejoin="round">
          <path d="M1.7 1.6L10.6 10.6C10.7 10.7 10.8 10.8 10.8 11 10.8 11.2 10.7 11.3 10.6 11.4L1.7 20.4" stroke-width="1.6" stroke="black"></path>
        </g>
      </svg>
    `
  }
  const renderClose = () => {
    return `
      <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
        <g fill="none" fill-rule="evenodd">
          <circle fill="#000" opacity=".05" cx="30" cy="30" r="30"/>
          <g stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
            <path d="m21 21 18 18M39 21 21 39"/>
          </g>
        </g>
      </svg>
    `
  }
  const renderItem = (src) => {
    return `
      <div class="w-screen">
        <div class="w-h-screen h-screen p-6 flex flex-col justify-center items-center mx-auto">
          <div class="block w-full">
            <div class="pb-full relative">
              <img class="zoom-img absolute top-1/2 -translate-y-1/2 left-0 object-contain w-full" src="${src}" />
            </div>
          </div>
        </div>
      </div>
    `
  }
  const renderZoom = (srcs) => {
    return `
      <div class="zoom-content fixed w-full h-full bg-gray-75 inset-0 z-50">
        <button class="zoom-close absolute top-5 right-5 transform-gpu transition-all scale-100 hover:scale-90 z-2">
          ${renderClose()}
        </button>
        <div class="h-screen w-full relative">
          <button class="zoom-prev p-4 transform rotate-180 absolute left-6 top-1/2 -translate-y-1/2 z-1">
            ${renderArrow()}
          </button>
          <div class="zoom-carousel mix-blend-multiply">
            ${srcs.map((src) => renderItem(src)).join('')}
          </div>
          <button class="zoom-next p-4 transform -translate-y-1/2 absolute right-6 top-1/2">
            ${renderArrow()}
          </button>
        </div>
      </div>
    `
  }

  const getSrcs = ($zoomTrigger) => {
    const srcs = []
    $zoomTrigger
      .closest('[class*="-carousel"]')
      .find('img')
      .each(function () {
        const src = $(this).attr('src')
        if (!src.includes('.svg')) {
          srcs.push(src)
        }
      })
    return srcs
  }

  let carousel

  $els.zoomTrigger.on('click', (e) => {
    const $this = $(e.currentTarget)
    const srcs = getSrcs($this)
    const zoom = renderZoom(srcs)
    const idx = $this.parent().index()

    // prevent scrolling
    $els.body.addClass('overflow-hidden').append(zoom)


    // init carousel
    carousel = new Flickity('.zoom-carousel', {
      prevNextButtons: false,
      draggable: false,
      pageDots: false,
      wrapAround: true,
      accessibility: false
    })

    // set index
    carousel.select(idx, false, true)
    
    // set focus trap
    setFocusTrap(e.currentTarget)   
  })

  function setFocusTrap(initialElement) {
    const focusableElements = [document.querySelector('.zoom-close'), document.querySelector('.zoom-prev'), document.querySelector('.zoom-next')]
    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]
    
    function trapFocus(e) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9
      let isEscPressed = e.key === 'Escape' || e.keyCode === 27
  
      if (!isTabPressed) {
        return
      }
  
      if (e.shiftKey) /* shift + tab */ {
        if (document.activeElement === firstElement) {
          lastElement.focus()
          e.preventDefault();
        }
      } else /* tab */ {
        if (document.activeElement === lastElement) {
          firstElement.focus()
          e.preventDefault()
        }
      }
    }

    // Attach the event listener to trap focus
    document.addEventListener('keydown', trapFocus);
  
    // Initially focus the first focusable element
    firstElement.focus()
  }

  function removeFocusTrap() {
    document.querySelector('#product-form a')?.focus()
    document.removeEventListener('keydown', trapFocus)
  }

  $els.body.on('click', '.zoom-content .zoom-prev', () => {
    carousel.previous()
  })
  $els.body.on('click', '.zoom-content .zoom-next', () => {
    carousel.next()
  })
  $els.body.on('click', '.zoom-content .zoom-close', (e) => {
    removeFocusTrap()
    carousel.destroy()
    $els.body.removeClass('overflow-hidden')
    $els.body.find('.zoom-content').remove()
  })
  $(document).on('keyup', (e) => {
    if (e.key === 'Escape') {
      removeFocusTrap()
      carousel.destroy()
      $els.body.removeClass('overflow-hidden')
      $els.body.find('.zoom-content').remove()
    }if (e.key === 'ArrowLeft') {
      carousel.previous()
    } else if (e.key === 'ArrowRight') {
      carousel.next()
    }
  })

})
